export const TEST_ID = {
  navCard: 'navCard',
  navCardButton: 'navCardButton',
};

export const NAV_CARD_WIDTH = 320;
export const NAV_CARD_HEIGHT = 180;
